











































import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";

@Component({
  data() {
    return {
      results: [],
      loading: false,
      error: null,
      simulationJSON: `{
        "perfil": 45,
        "plazo": 48,
        "cuotas": 45,
        "meses_gracia": 3,
        "tasa_mensual": 1.1,
        "dias_gracia": 5,
        "uso_plataforma": 100380,
        "prestamo": 125000000,
        "id_proyecto": 388,
        "nombre_proyecto": "CB INGENIERA",
        "id_inversionista": 321,
        "nombre_inversionista": "INVERSIONES FEPADA",
        "rut_inversonista": "76.400.275-K",
        "tipo_credito": 4,
        "fecha_entrega_dinero": "2019-06-17"
}`,
      headers: [
        {
          text: "Amortizacion capital",
          sortable: false
        },
        {
          text: "Amortizacion interes",
          sortable: false
        },
        {
          text: "Amortizacion total",
          sortable: false
        },
        {
          text: "Cuota",
          sortable: false
        },
        {
          text: "Costos RC",
          sortable: false
        },
        {
          text: "Inicio",
          sortable: false
        },
        {
          text: "Interes",
          sortable: false
        },
        {
          text: "Interes Neto",
          sortable: false
        },
        {
          text: "Interes pagado",
          sortable: false
        },
        {
          text: "Flujo inversionista",
          sortable: false
        },
        {
          text: "Meses",
          sortable: false
        },
        {
          text: "Numero cuota",
          sortable: false
        },
        {
          text: "Numero mes",
          sortable: false
        },
        {
          text: "Saldo insoluto inicio periodo",
          sortable: false
        },
        {
          text: "Saldo interes inicial",
          sortable: false
        },
        {
          text: "Saldo capital inicial",
          sortable: false
        },
        {
          text: "Uso plataforma",
          sortable: false
        },
        {
          text: "Vencimiento",
          sortable: false
        }
      ]
    };
  },
  beforeMount() {
    // @ts-ignore
    this.simulation();
  },
  methods: {
    async simulation() {
      this.$data.loading = true;
      this.$data.results = [];

      Axios.post(
        "https://dev.redcapital.cl/api/simulacion_proyecto_credito",
        {
          simulacion: JSON.parse(this.$data.simulationJSON)
        },
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "api-key":
              "A2yA10AiMBLWAciuqRuKVa63gJdqet.A9F.oG3EfS3ebj8c1eWvQiKOLiRJe"
          }
        }
      )
        .then(res => {
          this.$data.results =
            res.data.data.detalle_simulacion.resultado_simulacion;
          this.$data.error = null;
        })
        .catch(error => {
          this.$data.error = error.response.data;
        })
        .finally(() => {
          this.$data.loading = false;
        });
    }
  }
})
export default class SimulacionRaul extends Vue {}
